import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import { fetchCollection, updateTournamentInDb, getTournamentById } from './utils';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './login_signup.css';
import { auth } from '../../firebase';
import { createGolfCourse, createAssociation } from './utils'; // Make sure these exist or adjust as needed

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditTournament() {
    const query = useQuery();
    const tournamentId = query.toString().replace('?', '').replace('=', '');
    const navigate = useNavigate();

    // Form state (same as create_tournaments.js)
    const [loading, setLoading] = useState(true);

    const [previousEdits, setPreviousEdits] = useState([]);
    // user information
    const [userId, setUserId] = useState("")


    const refreshCoursesList = async () => {
        const golfCourseDocs = await fetchCollection("golfCourses");
        const golfCourseListLocal = [];
        golfCourseDocs.forEach((doc) => {
            const docData = doc.data();
            const courseDisplayName = `${docData.name} - ${docData.city}, ${docData.state}`;
            const golfCourseObject = {
                label: courseDisplayName,
                value: docData.name,
                name: docData.name,
                city: docData.city,
                state: docData.state,
                country: docData.country,
                id: doc.id
            };
            golfCourseListLocal.push(golfCourseObject);
        });
        setAllGolfCourses(golfCourseListLocal);
    };

    const refreshAssociationsList = async () => {
        const associationDocs = await fetchCollection("associations");
        const associationsListLocal = [];
        associationDocs.forEach((doc) => {
            const docData = doc.data();
            const associationInfoName = `${docData.name} - ${docData.associationType}`;
            const associationObject = {
                label: associationInfoName,
                value: docData.name,
                id: doc.id
            };
            associationsListLocal.push(associationObject);
        });
        setAllAssociations(associationsListLocal);
    };

    const [form, setForm] = useState({
        tournamentName: "",
        menWomen: null,
        levels: [],
        subLevels: [],
        tournamentTypes: [],
        associations: [],
        tournamentPage: "",
        golfCourses: [],
        startDate: new Date(),
        endDate: new Date(),
        signupEligibility: "",
        qualifierNeeded: false,
        otherSites: [],
        qualifierFor: [],
        qualifiers: [],
        relatedTournaments: []
    });

    // Options state
    const [allLevels, setAllLevels] = useState([]);
    const [allSublevels, setAllSubLevels] = useState([]);
    const [allTournamentTypes, setAllTournamentTypes] = useState([]);
    const [allAssociations, setAllAssociations] = useState([]);
    const [allGolfCourses, setAllGolfCourses] = useState([]);
    const [allTournaments, setAllTournaments] = useState([]);

    const menWomenList = [
        { label: "Men", value: "Men" },
        { label: "Women", value: "Women" },
        { label: "Both", value: "Both" }
    ];

    useEffect(() => {
        console.log('Editing tournament with ID:', tournamentId);
        async function fetchData() {
            setLoading(true);
            // Fetch user information from firebase auth
            const currentUser = auth.currentUser ? auth.currentUser.uid : ""
            setUserId(currentUser)
            // Fetch options (reuse logic from create_tournaments.js)
            // Fetch tournament levels
            const levelsDocs = await fetchCollection("tournamentLevels")
            const levelsLocal = []
            levelsDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const levelObject = {
                    label: docData.level,
                    value: docData.level
                }
                levelsLocal.push(levelObject)
            });
            setAllLevels(levelsLocal)

            // Fetch tournament sub-levels
            const subLevelsDocs = await fetchCollection("tournamentSubLevels")
            const subLevelsLocal = []
            subLevelsDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const subLevelObject = {
                    label: docData.subLevel,
                    value: docData.subLevel
                }
                subLevelsLocal.push(subLevelObject)
            });
            setAllSubLevels(subLevelsLocal)

            // Fetch tournament types
            const tournamentTypeListLocal = []
            const tournamentTypeDocs = await fetchCollection("tournamentTypes")
            tournamentTypeDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const golfCourseObject = {
                label: docData.type,
                value: docData.type,
                id: doc.id
                }
                tournamentTypeListLocal.push(golfCourseObject)
            });
            setAllTournamentTypes(tournamentTypeListLocal)

            const associationsListLocal = []
            const associationDocs = await fetchCollection("associations")
            associationDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const associationInfoName = `${docData.name} - ${docData.associationType}`
                const associationObject = {
                label: associationInfoName,
                value: docData.name,
                id: doc.id
                }
                associationsListLocal.push(associationObject)
            });
            setAllAssociations(associationsListLocal)

            // Fetch golf courses
            const golfCourseListLocal = []
            const golfCourseDocs = await fetchCollection("golfCourses")
            golfCourseDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const courseDisplayName = `${docData.name} - ${docData.city}, ${docData.state}`
                const golfCourseObject = {
                    label: courseDisplayName,
                    value: docData.name,
                    name: docData.name,
                    city: docData.city,
                    state: docData.state,
                    country: docData.country,
                    id: doc.id
                }
                golfCourseListLocal.push(golfCourseObject)
            });
            setAllGolfCourses(golfCourseListLocal)

            // Fetch all tournaments
            const allTournamentsListLocal = []
            const allTournamentsDocs = await fetchCollection("tournaments")
            allTournamentsDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                const tournamentDisplayName = `${docData.tournamentName} @ ${docData.golfCourses[0]}`
                const tournamentObject = {
                    label: tournamentDisplayName,
                    value: docData.tournamentName,
                    id: doc.id
                }
                allTournamentsListLocal.push(tournamentObject)
            })
            setAllTournaments(allTournamentsListLocal)

            // Fetch tournament data
            const tournament = await getTournamentById(tournamentId);
            console.log("Fetched tournament:", tournament);
            if (tournament) {
                // get golf courses from allGolfCourses
                const golfCoursesLocal = []
                tournament.golfCourses.forEach((courseName) => {
                    const course = golfCourseListLocal.find(gc => gc.name === courseName);
                    if (course) {
                        golfCoursesLocal.push(course);
                    } else {
                        console.warn(`Golf course "${courseName}" not found in allGolfCourses`);
                    }
                });
                console.log("Mapped golf courses:", golfCoursesLocal);

                // get qualifiers
                const qualifiersLocal = []
                tournament.qualifiers.forEach((qualifierInfo) => {
                    qualifiersLocal.push(qualifierInfo)
                })

                // get qualifierFor
                const qualifierForLocal = []
                tournament.qualifierFor.forEach((qualifierForInfo) => {
                    qualifierForLocal.push(qualifierForInfo)
                })

                // get other sites
                const otherSitesLocal = []
                tournament.otherSites.forEach((siteInfo) => {
                    otherSitesLocal.push(siteInfo)
                })

                // get related tournaments
                const relatedTournamentsLocal = []
                tournament.relatedTournaments.forEach((relatedTournamentInfo) => {
                    relatedTournamentsLocal.push(relatedTournamentInfo)
                })

                // get list of previous edits
                if (tournament.edits) {
                    setPreviousEdits(tournament.edits)
                }
                setForm({
                    tournamentName: tournament.tournamentName || "",
                    menWomen: menWomenList.find(opt => opt.value === tournament.menWomen) || null,
                    levels: (tournament.tournamentLevels || []).map(lvl => ({ label: lvl, value: lvl })),
                    subLevels: (tournament.tournamentSubLevels || []).map(sl => ({ label: sl, value: sl })),
                    tournamentTypes: (tournament.tournamentTypes || []).map(tt => ({ label: tt, value: tt })),
                    associations: (tournament.tournamentAssociations || []).map(a => allAssociations.find(opt => opt.value === a) || { label: a, value: a }),
                    tournamentPage: tournament.tournamentPage || "",
                    golfCourses: golfCoursesLocal,
                    startDate: tournament.startDate ? new Date(tournament.startDate) : new Date(),
                    endDate: tournament.endDate ? new Date(tournament.endDate) : new Date(),
                    signupEligibility: tournament.signupEligibility || "",
                    qualifierNeeded: tournament.qualifierNeeded || false,
                    otherSites: otherSitesLocal,
                    qualifierFor: qualifierForLocal,
                    qualifiers: qualifiersLocal,
                    relatedTournaments: relatedTournamentsLocal,
                });
            }
            setLoading(false);
            console.log("form:", tournament);
        }
        fetchData();
        // eslint-disable-next-line
    }, [tournamentId]);

    const handleChange = (field, value) => setForm(f => ({ ...f, [field]: value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        const startDateMonth = month[form.startDate.getMonth()];
        const startDateDay = form.startDate.getDate()
        const startDateYear = form.startDate.getFullYear()
        const startDateString = `${startDateMonth} ${startDateDay}, ${startDateYear}`
        const endDateMonth = month[form.endDate.getMonth()];
        const endDateDay = form.endDate.getDate()
        const endDateYear = form.endDate.getFullYear()
        const endDateString = `${endDateMonth} ${endDateDay}, ${endDateYear}`

        const levelsLocal = []
        form.levels.forEach((level) => {
            levelsLocal.push(level.value)
        })

        const subLevelsLocal = []
        form.subLevels.forEach((subLevel) => {
            subLevelsLocal.push(subLevel.value)
        })

        const tournamentTypesLocal = []
        form.tournamentTypes.forEach((tournamentType) => {
            tournamentTypesLocal.push(tournamentType.value)
        })

        const tournamentAssociationsLocal = []
        form.associations.forEach((association) => {
            tournamentAssociationsLocal.push(association.value)
        })

        const allGolfCourses = []
        const allCities = []
        const allStates = []
        const allCountries = []
        form.golfCourses.forEach((golfCourse) => {
            allGolfCourses.push(golfCourse.value)
            allCities.push(golfCourse.city)
            allStates.push(golfCourse.state)
            allCountries.push(golfCourse.country)
        })
        console.log("form.golfCourses:", form.golfCourses);

        // add edits
        const updatedEdits = previousEdits.slice(); // Copy previous edits
        updatedEdits.push({
            userId: userId,
            timestamp: new Date().toISOString()
        })
        // Prepare data for update (similar to create)
        const updatedData = {
            tournamentName: form.tournamentName,
            menWomen: form.menWomen?.value,
            tournamentLevels: levelsLocal,
            tournamentSubLevels: subLevelsLocal,
            tournamentTypes: tournamentTypesLocal,
            tournamentAssociations: tournamentAssociationsLocal,
            tournamentPage: form.tournamentPage,
            golfCourses: allGolfCourses,
            cities: allCities,
            states: allStates,
            countries: allCountries,
            startDate: startDateString,
            endDate: endDateString,
            signupEligibility: form.signupEligibility,
            qualifierNeeded: form.qualifierNeeded,
            otherSites: form.otherSites,
            qualifierFor: form.qualifierFor,
            qualifiers: form.qualifiers,
            relatedTournaments: form.relatedTournaments,
            edits: updatedEdits
        };
        console.log("Updating tournament with data:", updatedData);
        await updateTournamentInDb(tournamentId, updatedData);
        setLoading(false);
        navigate('/admin/listTournaments');
    };

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 600 }}>
                <h1 className="admin-login-title">Edit Tournament</h1>
                <form className="admin-login-form" style={{ gap: "1.5rem" }} onSubmit={handleSubmit}>
                    <div>
                        <label className="admin-login-label">Tournament Name</label>
                        <input className="admin-login-input" value={form.tournamentName} onChange={e => handleChange('tournamentName', e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Men/Women</label>
                        <Select isMulti={false} options={menWomenList} value={form.menWomen} onChange={v => handleChange('menWomen', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Level(s)</label>
                        <Select isMulti options={allLevels} value={form.levels} onChange={v => handleChange('levels', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Sub-Level(s)</label>
                        <Select isMulti options={allSublevels} value={form.subLevels} onChange={v => handleChange('subLevels', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Type</label>
                        <Select isMulti options={allTournamentTypes} value={form.tournamentTypes} onChange={v => handleChange('tournamentTypes', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Association(s)</label>
                        <Select isMulti options={allAssociations} value={form.associations} onChange={v => handleChange('associations', v)} />
                        <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
                            <Link target="_blank" rel="noopener noreferrer" to="/admin/createNewAssociation">
                                <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem" }}>
                                    Create New Association(s)
                                </button>
                            </Link>
                            <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem", background: "linear-gradient(90deg, #38bdf8 0%, #2563eb 100%)" }} onClick={refreshAssociationsList}>
                                Refresh Associations List
                            </button>
                        </div>
                    </div>
                    <div>
                        <label className="admin-login-label">Tournament Web Page</label>
                        <input className="admin-login-input" value={form.tournamentPage} onChange={e => handleChange('tournamentPage', e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Host Course(s)</label>
                        <Select isMulti options={allGolfCourses} value={form.golfCourses} onChange={v => handleChange('golfCourses', v)} />
                        <div style={{ display: "flex", gap: "1rem", marginTop: "0.5rem" }}>
                            <Link target="_blank" rel="noopener noreferrer" to="/admin/createNewCourse">
                                <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem" }}>
                                    Create New Course
                                </button>
                            </Link>
                            <button className="admin-login-btn" type="button" style={{ padding: "0.5rem 1rem", fontSize: "0.95rem", background: "linear-gradient(90deg, #38bdf8 0%, #2563eb 100%)" }} onClick={refreshCoursesList}>
                                Refresh Courses List
                            </button>
                        </div>
                    </div>
                    <div>
                        <label className="admin-login-label">Start Date</label>
                        <DatePicker value={form.startDate} onChange={date => handleChange('startDate', date)} />
                    </div>
                    <div>
                        <label className="admin-login-label">End Date</label>
                        <DatePicker value={form.endDate} onChange={date => handleChange('endDate', date)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Signup Eligibility</label>
                        <input className="admin-login-input" value={form.signupEligibility} onChange={e => handleChange('signupEligibility', e.target.value)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifier Needed?</label>
                        <Switch onChange={checked => handleChange('qualifierNeeded', checked)} checked={form.qualifierNeeded} />
                    </div>
                    <div>
                        <label className="admin-login-label">Other Sites</label>
                        <Select isMulti options={allTournaments} value={form.otherSites} onChange={v => handleChange('otherSites', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifier For</label>
                        <Select isMulti options={allTournaments} value={form.qualifierFor} onChange={v => handleChange('qualifierFor', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Qualifiers</label>
                        <Select isMulti options={allTournaments} value={form.qualifiers} onChange={v => handleChange('qualifiers', v)} />
                    </div>
                    <div>
                        <label className="admin-login-label">Related Tournaments</label>
                        <Select isMulti options={allTournaments} value={form.relatedTournaments} onChange={v => handleChange('relatedTournaments', v)} />
                    </div>
                    <div style={{ marginTop: "1.5rem" }}>
                        <button className="admin-login-btn" type="submit">
                            Save Changes
                        </button>
                        <button
                            className="admin-login-btn"
                            type="button"
                            style={{ background: "#e5e7eb", color: "#1e293b" }}
                            onClick={() => navigate('/admin/listTournaments')}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditTournament;